/*
 *
 * ConfirmReverseTransactionModal
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 30-Jun-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  titleModal: (
    <PortalMessage
      id='t.app.transactions.transactionDetails.titleModal'
      defaultMessage='Conferma storno'
    />
  ),
  descriptionModal: (amountReversed) => (
    <PortalMessage
      id='t.app.transactions.transactionDetails.descriptionModal'
      defaultMessage='Stai effettuando uno storno di {amountReversed}'
      values={{ amountReversed }}
    />
  ),
  subTitleModal: (
    <PortalMessage
      id='t.app.transactions.transactionDetails.subTitleModal'
      defaultMessage='Sei sicuro di voler stornare?'
    />
  ),
  labelPrimaryButtonModal: (
    <PortalMessage
      id='t.app.confirm'
      defaultMessage='Conferma'
    />
  ),
  labelSecondaryButtonModal: (
    <PortalMessage
      id='t.app.cancel'
      defaultMessage='Annulla'
    />
  )
}

export default formattedMessage
